import { useState, useCallback } from 'react';

interface NotificationData {
  id: string;
  type: 'success' | 'error' | 'info';
  title: string;
  message: string;
  duration?: number;
}

export const useNotification = () => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);

  const showNotification = useCallback((
    type: 'success' | 'error' | 'info',
    title: string,
    message: string,
    duration?: number,
    clearPrevious: boolean = false
  ) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    const notification: NotificationData = {
      id,
      type,
      title,
      message,
      duration
    };

    setNotifications(prev => {
      // Если clearPrevious = true, очищаем все предыдущие уведомления
      if (clearPrevious) {
        return [notification];
      }
      
      // Ограничиваем количество уведомлений до 2 максимум
      // Если добавляем новое и уже есть 2, удаляем самое старое
      const newNotifications = [...prev, notification];
      if (newNotifications.length > 2) {
        return newNotifications.slice(-2); // Берем последние 2
      }
      return newNotifications;
    });
  }, []);

  const removeNotification = useCallback((id: string) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  const clearAllNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const showSuccess = useCallback((title: string, message: string, duration?: number, clearPrevious?: boolean) => {
    showNotification('success', title, message, duration, clearPrevious);
  }, [showNotification]);

  const showError = useCallback((title: string, message: string, duration?: number, clearPrevious?: boolean) => {
    showNotification('error', title, message, duration, clearPrevious);
  }, [showNotification]);

  const showInfo = useCallback((title: string, message: string, duration?: number, clearPrevious?: boolean) => {
    showNotification('info', title, message, duration, clearPrevious);
  }, [showNotification]);

  return {
    notifications,
    showNotification,
    removeNotification,
    clearAllNotifications,
    showSuccess,
    showError,
    showInfo
  };
}; 